import React from "react";
import {List} from "@mui/material";
const SchoolsSelector = (
    {isVisible = isVisible,
        setSelectedSchoolName = {setSelectedSchoolName},
        setSelectedSchoolCode = {setSelectedSchoolCode},
        showisVisible={showisVisible}}) =>{
    const schoolsArray =  [
        {
            "ID": 233,
            "MERCHANT_CODE": "SCHS1101",
            "BUSINESSNAME": "MARAGUA RIDGE SECONDARY SCHOOL"
        },
        {
            "ID": 234,
            "MERCHANT_CODE": "SCHS1100",
            "BUSINESSNAME": "MUGEKA SECONDARY SCHOOL"
        },
        {
            "ID": 235,
            "MERCHANT_CODE": "SCHS0689",
            "BUSINESSNAME": "MURANGA HIGH SCHOOL"
        },
        {
            "ID": 236,
            "MERCHANT_CODE": "SCHS0590",
            "BUSINESSNAME": "MUGOIRI GIRLS HIGH  SCHOOL"
        },
        {
            "ID": 128,
            "MERCHANT_CODE": "SCHS0406",
            "BUSINESSNAME": "KIAMURI SECONDARY SCHOOL"
        }
    ]

    return (
        <>
            {isVisible ? <>
                <div className="scrollable_component_warpper">
                    <List sx={{width: '100%',
                        position: 'relative',
                        overflow: 'auto',
                        maxHeight: 400,
                        '& ul': { padding: 0 }
                    }}>
                        {schoolsArray.map((value, index) => (
                            <div className="scrollable_component card_cont" onClick={
                                () => {
                                    showisVisible(false)
                                    setSelectedSchoolCode(value.MERCHANT_CODE)
                                    setSelectedSchoolName(value.BUSINESSNAME)
                                }
                            }>
                                <div className="card__content" >
                                    <div className="image-holder" ></div>
                                    <h3>{value.BUSINESSNAME}</h3>

                                </div>
                            </div>
                        ))}
                    </List>
                </div>


                </>
                :<></>
                }
            </>
                )
            }
export default SchoolsSelector;